import React, { useEffect, useState } from "react";

import {
  fetchConexionSaml,
  fetchConexionesSaml,
} from "../../../../shared/fetchers/saml";
import AgregarNuevoClienteSAMLForm from "../../adicionar-elementos/agregar-nuevo-cliente-saml-form";
import Skeleton from "@material-ui/lab/Skeleton";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import CustomGreenButton from "../../../../components/shared/custom-green-button";
import pdf1 from "../../../../documents/crear-saml.pdf";
import pdf2 from "../../../../documents/guia-azure.pdf";
import pdf3 from "../../../../documents/guia-gsuite.pdf";
import swal from "sweetalert";

const EditarClienteSAML = () => {
  const [idps, setIdps] = useState([]);
  const [loadingList, setLoadingList] = useState(true);
  const [loadingIdp, setLoadingIdp] = useState(false);
  const [selectedIdp, setSelectedIdp] = useState(null);

  useEffect(() => {
    getIdps();
  }, []);

  const getIdps = async () => {
    setLoadingList(true);
    try {
      const data = await fetchConexionesSaml();
      if (data.status === 1) {
        setIdps(data.data || []);
      } else {
        setIdps([]);
        if (data.info) {
          await swal({
            title: "Aviso",
            text: data.info,
            icon: "info",
          });
        }
      }
    } catch (error) {
      console.log(error);
      setIdps([]);
      await swal({
        title: "Error",
        text: "No se pudieron cargar los IdP SAML",
        icon: "error",
      });
    }
    setLoadingList(false);
  };

  const getIdpDetail = async (idInstitutoSAML) => {
    const data = await fetchConexionSaml(idInstitutoSAML);
    if (data.status === 1) return data.data;
    throw new Error(data.info || "No se pudo cargar el IdP");
  };

  const changeIdp = async (newIdp) => {
    if (!newIdp) {
      setSelectedIdp(null);
      return;
    }

    setLoadingIdp(true);
    try {
      const fullIdp = await getIdpDetail(newIdp.idInstitutoSAML);
      setSelectedIdp(fullIdp || newIdp);
    } catch (error) {
      // Si falla el detalle, usar los datos de la lista
      setSelectedIdp(newIdp);
      await swal({
        title: "Aviso",
        text:
          error.message ||
          "Se cargaron los datos básicos del IdP. Algunos campos podrían estar incompletos.",
        icon: "warning",
      });
    }
    setLoadingIdp(false);
  };

  const handleCancel = () => {
    setSelectedIdp(null);
  };

  return (
    <>
      <ButtonGroup size="small" className="my-3">
        <a className="mr-2" href={pdf1} target="_blank" rel="noreferrer">
          <CustomGreenButton>Manual General</CustomGreenButton>
        </a>
        <a className="mr-2" href={pdf2} target="_blank" rel="noreferrer">
          <CustomGreenButton>Manual Azure</CustomGreenButton>
        </a>
        <a href={pdf3} target="_blank" rel="noreferrer">
          <CustomGreenButton>Manual Gsuite</CustomGreenButton>
        </a>
      </ButtonGroup>

      <form onSubmit={(e) => e.preventDefault()}>
        <label className="admin-label-text mt-3 d-block">
          Buscar IdP SAML*
        </label>
        {loadingList ? (
          <>
            <Skeleton animation="wave" />
            <Skeleton animation="wave" />
          </>
        ) : (
          <Autocomplete
            options={idps}
            getOptionLabel={(option) => {
              if (!option) return "";
              const id = option.idInstitutoSAML || "";
              const user = option.username ? ` (${option.username})` : "";
              return `${id}${user}`;
            }}
            getOptionSelected={(option, value) =>
              option?.idInstitutoSAML === value?.idInstitutoSAML
            }
            value={selectedIdp}
            onChange={(_e, value) => changeIdp(value)}
            noOptionsText="Sin resultados"
            disabled={!!selectedIdp || loadingIdp}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                size="small"
                fullWidth
                placeholder="Selecciona un idInstitutoSAML"
                style={{
                  fontFamily: "'Noto Sans JP', sans-serif",
                }}
              />
            )}
          />
        )}
      </form>

      {loadingIdp && (
        <div className="mt-3">
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
        </div>
      )}

      {selectedIdp && !loadingIdp && (
        <AgregarNuevoClienteSAMLForm
          idp={selectedIdp}
          edit
          cancelFn={handleCancel}
          refreshIdps={getIdps}
        />
      )}
    </>
  );
};

export default EditarClienteSAML;
